module.exports = __webpack_public_path__ + "77fdfd4f5dd4766df0d68efd8b88d077.spring.svg";